import React, { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import PublicApp from "app/Public";
import "./style.css";
import SplashScreen from "pages/SplashScreen";
import PrivateRoutes from "app/PrivateRoutes";
import { oauthClient, scopes } from "./Auth";
import { AppContext } from "./AppContext";
import LoaderAnimation from "pages/LoaderAnimation";

import CacheBuster from 'react-cache-buster';
import { version } from '../package.json';

import { StoreProvider } from "easy-peasy";
import { store } from './store';
import { createTheme, ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { ThemeProvider as ThemeProviderLegacy } from "@mui/styles";

import { alpha } from "@mui/material";

import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "./common/ApiUrls";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const accessToken = localStorage.getItem("accessToken");
const refreshToken = localStorage.getItem("refreshToken");
let oauthToken = null;
let isAuthenticated = null;
if (accessToken != null) {
  oauthToken = oauthClient.createToken(accessToken, refreshToken, "bearer");
}

// AXIM Orange - #f16824
// AXIM Blue - #03049b
// Lighter Blue - ##7171C5
// AXIM Green - #7acd31
// Light Gray - #eef6f7
// Light Orange - #f5a983
// Lighter Orange - #F7C9B3
// Lighter Green - #6cb80d
// Even Lighter Green - #cbe9b1

function App() {
  const isProduction = process.env.NODE_ENV === 'production';
  const [checkingData, setCheckingData] = useState(true);
  const [apiTheme, setApiTheme] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setCheckingData(false);
    }, 1500);
    isAuthenticated = oauthToken ? true : false;
  }, []);
  //const token = localStorage.getItem('token');

  useEffect(() => {
    if (isLoading) {
      loadTheme();
    }
  }, []);

  const loadTheme = () => {
    apiGet(apiUrls.getTheme).then(
      (response) => {
        setApiTheme(response.data);
        setIsLoading(false);
      });
  }

  const theme = React.useMemo(() =>
    createTheme({
      palette: {
        mode: 'light',
        primary: {
          main: apiTheme?.primary ?? "#000",
          contrastText: apiTheme?.primaryText ?? "#FFF",
          veryLight: apiTheme ? alpha(apiTheme.primary, 0.1) : "#000",
        },
        secondary: {
          main: apiTheme?.secondary ?? "#808080",
          veryLight: apiTheme ? alpha(apiTheme.secondary, 0.1) : alpha("#808080", 0.1),
        },
        Red: { main: "#FF0000" },
        Yellow: { main: "#FFA500" },
        Green: { main: "#008000" },
        Grey: { main: "#808080" },
      },
      components: {
        MuiTooltip: {
          styleOverrides: {
            tooltip: {
              backgroundColor: apiTheme?.primary ?? "#000",
            }
          }
        },
        MuiDialogTitle: {
          styleOverrides: {
            root: {
              backgroundColor: apiTheme?.primary ?? "#000",
              marginBottom: "15px",
            }
          }
        }
      },
      overrides: {
        MUIDataTableToolbarSelect: {
          title: {
            fontWeight: 600,
          }
        },
        MuiTableRow: {
          root: {
            '&$selected': {
              backgroundColor: "#7acd31 !important"
            },
            '&$selected&$hover:hover': {
              backgroundColor: "#6cb80d !important"
            }
          }
        }
      }
    }), [apiTheme]);
  return (
    <CacheBuster
      currentVersion={version}
      isEnabled={isProduction} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      loadingComponent={<LoaderAnimation/>} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
    >
    <BrowserRouter>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <ThemeProviderLegacy theme={theme}>
            <StoreProvider store={store}>
              <AppContext.Provider value={{ oauthToken }}>
                <div className="app--wrapper">
                  {checkingData ? (
                    <LoaderAnimation className={SplashScreen.animateLoader} centerAtPage={true} />
                  ) : isAuthenticated ? (
                    <PrivateRoutes updateTheme={loadTheme} />
                  ) : (
                    <PublicApp />
                  )}
                  <ToastContainer position="top-right" autoClose={3000} />
                </div>
              </AppContext.Provider>
            </StoreProvider>
          </ThemeProviderLegacy>
        </ThemeProvider>
      </StyledEngineProvider>
    </BrowserRouter>
    </CacheBuster>
  );
}

export default App;
